"use client";

import { useRouter } from "next/navigation";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { VerifySignInCodeRequest } from "cmw-client";
import { browserCmw } from "@/lib/ky/browser";
import { setSession } from "@/lib/session";
import { routes } from "@/lib/routes";
import { useSignInCodeRetryStore } from "@/lib/otp-retry-store";

export type SignInWithCodeInput = VerifySignInCodeRequest;

export function useSignInWithCode() {
  const router = useRouter();
  const queryClient = useQueryClient();
  const setRetryAt = useSignInCodeRetryStore((state) => state.setRetryAt);

  return useMutation({
    mutationFn: async (body: SignInWithCodeInput) => {
      const auth = await browserCmw.auth.signInWithCode(body);

      await setSession(auth);

      return auth;
    },
    onSuccess: () => {
      setRetryAt(null);
      queryClient.clear();
      router.replace(routes.dashboard.url);
      router.refresh();
    },
  });
}
